// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__M8oWn"};